export default __webpack_public_path__ + "static/media/330_portfolio02-fr-mobile.43fc9957.png";